import { render, staticRenderFns } from "./LogBody.vue?vue&type=template&id=64c78393&"
import script from "./LogBody.vue?vue&type=script&lang=ts&"
export * from "./LogBody.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports